import {
  getArticle,
  getBasicCategories,
  getCategories,
  getTaxons,
  getArticles,
  getPerLanguage,
  getArticleSentences,
  getTranslations,
  createArticle,
  updateArticle,
  deleteArticle,
  createPerLanguage,
  createSentence,
  createTranslation,
  randomSentences,
} from 'utils/queries/article';

export const articleEndpoints = (build) => ({
  getArticle: build.query({
    query: (slug) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getArticle,
        variables: { slug },
      }),
    }),
    transformResponse: (response) => response.data.getArticle,
  }),
  getCategories: build.query({
    query: (taxonId) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getCategories,
        variables: { taxonId },
      }),
    }),
    transformResponse: (response) => response.data.getCategories,
  }),
  getBasicCategories: build.query({
    query: (taxonId) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getBasicCategories,
        variables: { taxonId },
      }),
    }),
    transformResponse: (response) => response.data.getCategories,
  }),
  /*
  getTaxons: build.query({
    query: () => ({
      method: 'POST',
      body: JSON.stringify({
        query: getTaxons,
      }),
    }),
    transformResponse: (response) => response.data.getTaxons,
  }),*/
  getArticles: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getArticles,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.getArticles,
  }),
  getPerLanguage: build.query({
    query: (articleId) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getPerLanguage,
        variables: { articleId },
      }),
    }),
    transformResponse: (response) => response.data.getPerLanguage,
  }),
  getSentences: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getArticleSentences,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.getSentences,
  }),
  getTranslations: build.query({
    query: () => ({
      method: 'POST',
      body: JSON.stringify({
        query: getTranslations,
      }),
    }),
    transformResponse: (response) => response.data.getTranslations,
  }),
  createArticle: build.mutation({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: createArticle,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.createArticle,
  }),
  updateArticle: build.mutation({
    query: ({ id, input }) => ({
      method: 'POST',
      body: JSON.stringify({
        query: updateArticle,
        variables: { id, input },
      }),
    }),
    transformResponse: (response) => response.data.updateArticle,
  }),
  deleteArticle: build.mutation({
    query: (id) => ({
      method: 'POST',
      body: JSON.stringify({
        query: deleteArticle,
        variables: { id },
      }),
    }),
    transformResponse: (response) => response.data.deleteArticle,
  }),
  createPerLanguage: build.mutation({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: createPerLanguage,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.createPerLanguage,
  }),
  createSentence: build.mutation({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: createSentence,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.createSentence,
  }),
  createTranslation: build.mutation({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: createTranslation,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.createTranslation,
  }),
  randomSentences: build.query({
    query: (number = 10) => ({
      method: 'POST',
      body: JSON.stringify({
        query: randomSentences,
        variables: { number },
      }),
    }),
    transformResponse: (response) => response.data.randomSentences,
  }),
});
